<template>
    <div>
        <div v-if="projectAssessmentData.length===0" class="alert alert-warning mb-0">没有考核项目信息</div>
        <table v-else class="table table-bordered mb-0">
            <thead>
            <tr>
                <th class="text-center align-middle" style="width: 10%">序号</th>
                <th class="text-center align-middle" style="width: 35%">项目</th>
                <th class="text-center align-middle" style="width: 45%">内容</th>
                <th class="text-center align-middle" style="width: 10%">分值</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in projectAssessmentData" :key="item.assessmentId">
                <td class="text-center align-middle">{{ index + 1 }}</td>
                <td class="text-left align-middle">{{ item.assessment }}</td>
                <td class="text-left align-middle">{{ item.assessmentContent }}</td>
                <td class="text-center align-middle">{{ item.score }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import projectApi from "@/utils/api/project";

export default {
    name: "ProjectAssessmentView",
    props: {
        projectId: {type: String, required: true},
    },
    data: function () {
        return {
            projectAssessmentData: [],
        };
    },
    computed: {
        totalScore() {
            let result = 0;
            for (let item of this.projectAssessmentData) {
                result += item.score;
            }
            return result;
        }
    },
    mounted() {
        this.getProjectAssessmentData();
    },
    methods: {
        getProjectAssessmentData() {
            projectApi.project.assessment.getProjectAssessmentData(this.projectId).then(res => {
                this.projectAssessmentData = res.data;
            });
        },
    }
}
</script>

<style scoped>

</style>